import React from 'react';
import Style from './responsiveContainer.module.css';

export default function ResponsiveContainer({ children }) {
    return <div className={Style['responsive-container']}>{children}</div>;
}
